var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsBoolean, IsEnum, IsOptional, IsString } from "class-validator";
export var ContactMethod;
(function (ContactMethod) {
    ContactMethod["EMAIL"] = "EMAIL";
    ContactMethod["TEXT"] = "TEXT";
    ContactMethod["CALL"] = "CALL";
    ContactMethod["DO_NOT_CONTACT"] = "DO_NOT_CONTACT";
})(ContactMethod || (ContactMethod = {}));
export var UnderstandingHealthData;
(function (UnderstandingHealthData) {
    UnderstandingHealthData["ALL"] = "ALL";
    UnderstandingHealthData["OVERVIEW_ONLY"] = "OVERVIEW_ONLY";
})(UnderstandingHealthData || (UnderstandingHealthData = {}));
export class ConsentConfigInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsOptional(),
    IsBoolean()
], ConsentConfigInput.prototype, "excludeCurrentDataExplanationFromOnboarding", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], ConsentConfigInput.prototype, "showDeidentifiedDataExplanantion", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], ConsentConfigInput.prototype, "showExternalExplanation", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], ConsentConfigInput.prototype, "showInternalExplanation", void 0);
__decorate([
    IsOptional(),
    IsEnum(UnderstandingHealthData)
], ConsentConfigInput.prototype, "understandingHealthData", void 0);
__decorate([
    IsOptional(),
    IsEnum(ContactMethod)
], ConsentConfigInput.prototype, "healthExPreferredContactMethod", void 0);
export class ConsentConfig extends ConsentConfigInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], ConsentConfig.prototype, "healthSystemId", void 0);
export class ConsentConfigTemplate extends ConsentConfigInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], ConsentConfigTemplate.prototype, "id", void 0);
__decorate([
    IsString()
], ConsentConfigTemplate.prototype, "name", void 0);
__decorate([
    IsBoolean()
], ConsentConfigTemplate.prototype, "isDefault", void 0);
